
<template>

    <DashboardContainer :style="'px-0 mx-0'">

        <div class="mt-4">

            <DashboardCard
                    header-title="SMS Config"
                    :refreshButton="true"
                    @refresh="loadInstitutions"
            >

                <div class="row">

                    <div class="col-md-6 mb-4">

                        <FormLabel
                                label-text="Institution ID"
                                :required="true"
                        />

                        <Select
                                v-model="configData.institutionId"
                                :options="institutions"
                                optionLabel="displayName"
                                optionValue="id"
                                placeholder="Select Institution"
                                :class="errors.institutionId ? 'p-invalid w-100' : 'w-100'"
                        />

                        <small
                                class="p-error"
                                v-if="errors.institutionId"
                        >
                            {{ errors.institutionId }}
                        </small>

                    </div>


                    <div class="col-md-6 mb-4">

                        <FormLabel
                                label-text="Sender ID"
                                :required="true"
                        />

                        <InputText
                                v-model="configData.senderId"
                                placeholder="Sender ID"
                                :class="errors.senderId ? 'p-invalid w-100' : 'w-100'"
                        />

                        <small
                                class="p-error"
                                v-if="errors.senderId"
                        >
                            {{ errors.senderId }}
                        </small>

                    </div>


                    <div class="col-md-6 mb-4">

                        <FormLabel
                                label-text="PE ID"
                                :required="true"
                        />

                        <InputText
                                v-model="configData.peId"
                                placeholder="PE ID"
                                :class="errors.peId ? 'p-invalid w-100' : 'w-100'"
                        />

                        <small
                                class="p-error"
                                v-if="errors.peId"
                        >
                            {{ errors.peId }}
                        </small>

                    </div>


                    <div class="col-md-6 mb-4">

                        <FormLabel
                                label-text="DCS"
                                :required="true"
                        />

                        <InputText
                                v-model="configData.dcs"
                                placeholder="DCS"
                                :class="errors.dcs ? 'p-invalid w-100' : 'w-100'"
                        />

                        <small
                                class="p-error"
                                v-if="errors.dcs"
                        >
                            {{ errors.dcs }}
                        </small>

                    </div>


                    <div class="col-md-6 mb-4">

                        <FormLabel
                                label-text="Flash SMS"
                                :required="true"
                        />

                        <InputText
                                v-model="configData.flashSms"
                                placeholder="Flash SMS"
                                :class="errors.flashSms ? 'p-invalid w-100' : 'w-100'"
                        />

                        <small
                                class="p-error"
                                v-if="errors.flashSms"
                        >
                            {{ errors.flashSms }}
                        </small>

                    </div>


                    <div class="col-md-12 mb-4">

                        <FormLabel
                                label-text="Token"
                                :required="true"
                        />

                        <Textarea
                                v-model="configData.token"
                                rows="5"
                                :class="errors.token ? 'p-invalid w-100' : 'w-100'"
                                placeholder="Access Token"
                                :autoResize="true"
                        />

                        <small
                                class="p-error"
                                v-if="errors.token"
                        >
                            {{ errors.token }}
                        </small>

                    </div>


                    <div class="col-md-6 mb-4">

                        <div class="form-check mt-4">

                            <input
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="configData.active"
                            >

                            <label class="form-check-label">
                                Active
                            </label>

                        </div>

                    </div>

                </div>


                <div class="col-md-12 mt-3">

                    <Button
                            class="w-100"
                            :label="configData.id ? 'Update' : 'Save'"
                            :icon="configData.id ? 'pi pi-refresh' : 'pi pi-save'"
                            severity="primary"
                            @click="save"
                    />

                </div>

            </DashboardCard>

        </div>

    </DashboardContainer>

</template>

<script>

import DashboardContainer from "@/dashboard/containers/DashboardContainer.vue";
import DashboardCard from "@/dashboard/containers/DashboardCard.vue";

import Select from "primevue/select";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";

import FormLabel from "@/components/FormLabel.vue";

import {SMS_CONFIG_MODEL} from "@/dashboard/sms/Sms";

export default {

    name: "CreateSmsConfig",

    components : {
        DashboardContainer,
        DashboardCard,
        Button,
        InputText,
        Textarea,
        FormLabel,
        Select,
    },

    props : {
        config : {
            type : Object,
            required : true
        }
    },

    data(){
        return{

            institutions : [],

            errors : {},

            configData : {
                ...SMS_CONFIG_MODEL
            }
        }
    },

    methods : {

        save(){

            if(!this.validate()) return;

            let data = {
                ...this.configData
            };

            let url = "/sms-config/save";

            if(data.id){
                url = "/sms-config/update";
            }

            this.$api.post(url, data)
                    .then(response => {

                        this.$root['showAlert'](
                                'success',
                                'SMS Config',
                                response.message
                        );

                        this.configData = {
                            ...SMS_CONFIG_MODEL
                        };

                    }).catch(error => {

                this.$root['handleApiError'](
                        error,
                        'SMS Config'
                );

            });

        },

        validate(){

            this.errors = {};

            if(!this.configData.institutionId){
                this.errors.institutionId =
                        "Institution is required";
            }

            if(!this.configData.senderId){
                this.errors.senderId =
                        "Sender ID is required";
            }

            if(!this.configData.peId){
                this.errors.peId =
                        "PE ID is required";
            }

            if(!this.configData.token){
                this.errors.token =
                        "Token is required";
            }

            return Object.keys(this.errors).length === 0;

        },

        loadInstitutions(){

            let payload = {
                page : 1,
                size : 1000,
                blockSelector : "ALL",
                institutionType : "GENERAL",
                clientTimezone : "Asia/Calcutta"
            };

            this.$api.post(
                    "/institution/get",
                    payload
            ).then(response => {

                this.institutions =
                        response.content.map(singleInstitution => {

                            return {
                                ...singleInstitution,

                                displayName :
                                        singleInstitution.id +
                                        " - " +
                                        singleInstitution.name.toUpperCase()
                            };

                        });

            }).catch(error => {

                this.$root['handleApiError'](
                        error,
                        "Institution Loading"
                );

            });

        },

    },

    watch : {

        config : {

            immediate : true,

            handler(newValue){

                this.configData = {
                    ...newValue
                };
            }
        }
    },

    beforeMount() {

        this.loadInstitutions();

    }

}
</script>

<style scoped lang="scss">

</style>
